import { render } from "./update_password.vue?vue&type=template&id=76de1c53&scoped=true"
import script from "./update_password.vue?vue&type=script&lang=js"
export * from "./update_password.vue?vue&type=script&lang=js"

import "./update_password.vue?vue&type=style&index=0&id=76de1c53&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76de1c53"]])

export default __exports__